import React from 'react';

type Props = {
  children: React.ReactNode;
  onReset?: () => void;
};

type State = {
  hasError: boolean;
  error?: Error | null;
};

export default class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: any) {
    // Send to logging endpoint if available
    // console.error will help during development
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 w-full text-left">
          <div className="bg-rose-50 border border-rose-100 rounded-xl p-4">
            <h4 className="text-sm font-bold text-rose-700">Erro ao abrir o modal</h4>
            <p className="text-xs text-rose-600 mt-2">Ocorreu um erro ao renderizar este diálogo. Você pode fechar e tentar novamente.</p>
            <div className="mt-3 flex justify-end">
              <button
                onClick={() => this.props.onReset && this.props.onReset()}
                className="px-3 py-2 text-xs font-bold bg-white border border-rose-200 rounded-xl text-rose-700"
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children as React.ReactElement;
  }
}
